<!--
component: BrowseBuildingSekkei
author: Ken Nakamura
description: 建築計画概要書（第一面 設計者）
-->
<template>
  <section>
    <div v-show="startIndex==0 && endIndex>0" class="gaiyo-row">
      <hr>
      <div class="gaiyo-major-title">
      【3.設計者】
      </div>
    </div>
    <div v-for="(sekkei, index) in sekkeis" :key="index">
      <div v-show="index>=startIndex && index<endIndex" class="person-block">
        <div class="gaiyo-row">
          <div v-show="index==0" class="gaiyo-person-type">（代表となる設計者）</div>
          <div v-show="index==1" class="gaiyo-person-type"><br>（その他の設計者）</div>
        </div>
        <div class="gaiyo-row">
          <div v-show="index>1"><br></div>
          <div class="gaiyo-minor-title">【ｲ.資格】</div>
          <div class="gaiyo-element left-40">&nbsp;&nbsp;（{{getShikaku(sekkei.sksY_SKK_SKBT)}}</div>
          <div class="gaiyo-element left-65">）建築士</div>
          <div class="gaiyo-element left-90">（{{getRegister(sekkei.sksY_TRK_KKN)}}</div>
          <div class="gaiyo-element left-115">&nbsp;）登録第&nbsp;{{sekkei.sksY_TRK_NO}}&nbsp;号</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾛ.氏名】</div>
          <div class="gaiyo-element left-45">{{sekkei.sksY_NAME}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾊ.建築士事務所名】</div>
          <div class="gaiyo-element left-40">&nbsp;&nbsp;（{{getShikaku(sekkei.skjM_SKK_SKBT)}}</div>
          <div class="gaiyo-element left-65">）建築士事務所</div>
          <div class="gaiyo-element left-90">（{{getRegister(sekkei.skjM_TRK_KKN)}}</div>
          <div class="gaiyo-element left-115">&nbsp;）登録第&nbsp;{{sekkei.skjM_TRK_NO}}&nbsp;号</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-element left-45">{{sekkei.skjM_NAME}}</div>
          <div v-for="(n,index) in wordwrap(sekkei.skjM_NAME,40)" :key="`skjm-name-${index}`">
            <br v-show="index>0"></div>
        <br></div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾆ.郵便番号】</div>
          <div class="gaiyo-element left-45">{{sekkei.skjM_POSTNO}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾎ.所在地】</div>
          <div class="gaiyo-element left-45">{{sekkei.skjM_ADDR}}</div>
          <div v-for="(n,index) in wordwrap(sekkei.skjM_ADDR,40)" :key="`skjm-addr-${index}`">
            <br v-show="index>0"></div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾍ.電話番号】</div>
          <div class="gaiyo-element left-45">{{sekkei.skjM_TELNO}}</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-minor-title">【ﾄ.作成又は確認した設計図書】</div>
          <div class="gaiyo-element left-60">{{sekkei.bK_NAME}}</div>
        </div>
      </div>
    </div>
    <div v-show="useAdditional">
      <div class="gaiyo-row">
        <br>
        <div class="gaiyo-person-type">（構造設計一級建築士又は設備設計一級建築士である旨の表示をした者）</div>
      </div>
      <div class="gaiyo-row">
        <div class="gaiyo-element left-05">上記の設計者の内、</div>
        <br>
        <div class="gaiyo-element left-05">
          <checkbox :checked="additional.law20_2_1.length>0" caption="建築士法第20条の２第１項の表示をした者" />
        </div>
        <br>
        <div v-for="(s, index) in additional.law20_2_1" :key="`a-${index}`">
          <div class="gaiyo-element left-05">【ｲ.氏名】</div>
          <div class="gaiyo-element left-50">{{ s.name }}</div>
          <br>
          <div class="gaiyo-element left-05">【ﾛ.資格】</div>
          <div class="gaiyo-element left-30">構造設計一級建築士交付第 {{ s.shikakuNo }} 号</div>
          <br>
        </div>
        <div class="gaiyo-element left-05">
          <checkbox :checked="additional.law20_2_3.length>0" caption="建築士法第20条の２第３項の表示をした者" />
        </div>
        <br>
        <div v-for="(s, index) in additional.law20_2_3" :key="`b-${index}`">
          <div class="gaiyo-element left-05">【ｲ.氏名】</div>
          <div class="gaiyo-element left-30">{{ s.name }}</div>
          <br>
          <div class="gaiyo-element left-05">【ﾛ.資格】</div>
          <div class="gaiyo-element left-30">構造設計一級建築士交付第 {{ s.shikakuNo }} 号</div>
          <br>
        </div>
        <div class="gaiyo-element left-05">
          <checkbox :checked="additional.law20_3_1.length>0" caption="建築士法第20条の３第１項の表示をした者" />
        </div>
        <br>
        <div v-for="(s, index) in additional.law20_3_1" :key="`c-${index}`">
          <div class="gaiyo-element left-05">【ｲ.氏名】</div>
          <div class="gaiyo-element left-30">{{ s.name }}</div>
          <br>
          <div class="gaiyo-element left-05">【ﾛ.資格】</div>
          <div class="gaiyo-element left-30">設備設計一級建築士交付第 {{ s.shikakuNo }} 号</div>
          <br>
        </div>
        <div class="gaiyo-element left-05">
          <checkbox :checked="additional.law20_3_3.length>0" caption="建築士法第20条の３第３項の表示をした者" />
        </div>
        <br>
        <div v-for="(s, index) in additional.law20_3_3" :key="`d-${index}`">
          <div class="gaiyo-element left-05">【ｲ.氏名】</div>
          <div class="gaiyo-element left-30">{{ s.name }}</div>
          <br>
          <div class="gaiyo-element left-05">【ﾛ.資格】</div>
          <div class="gaiyo-element left-30">設備設計一級建築士交付第 {{ s.shikakuNo }} 号</div>
          <br>
        </div>
      </div>
      <div class="gaiyo-row">
      </div>
    </div>
  </section>
</template>

<script>
import constants from '../../common/constants'
import Checkbox from '../../components/Checbox.vue'

export default {
  components: {
    Checkbox,
  },
  props: {
    sekkeis: {
      type: Array,
      default: () => [],
    },
    startIndex: {
      type: Number,
      default: () => 0
    },
    endIndex: {
      type: Number,
      default: () => 99
    },
    useAdditional: {
      type: Boolean,
      default: () => false
    },
    additional: {
      type: Object,
      default: () => null
    }
  },
  computed: {
  },
  methods: {
    getShikaku(code) {
      const shikaku = constants.shikakuKubun[code];
      if (shikaku == null) {
        return '';
      }
      else {
        return shikaku.name;
      }
    },
    getRegister(code) {
      const rgst = constants.Register[code];
      if (rgst == null) {
        return '';
      }
      else {
        return rgst.name;
      }
    },
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../styles/common/common.css";
</style>